import { Icon } from 'app/components/common/Icon';
import { WeekRangePicker } from 'app/components/common/DatePickers';
import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { AgtAkumaPlanerVM, AkumaPlanerArtSchema } from 'app/stores/ui/agt.akumaplaner.ui.store';
import { formatNum } from 'app/utils';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { AkumaPlanerSankeyChart } from './AkumaPlanerSankeyChart';
import { useHistoryWithQuery } from 'app/hooks/useHistoryWithQuery';
import _ from 'lodash';
import { AkumaPlanerLegend } from './AkumaPlanerLegend';

export const AkumaOnePager = observer(() => {
	return (
		<>
			<a href={'AKUMA_Booklet.pdf'} target="_blank" rel="noreferrer" className="button is-primary is-small has-icon is-inverted">
				<span>AKUMA Booklet</span> <Icon iconClass="external-link-square" />
			</a>
		</>
	);
});

export const AkumaPlanerOptions = observer(() => {
	const { agtAkumaPlanerUiStore } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtAkumaPlanerUiStore.minKwCurrent = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtAkumaPlanerUiStore.maxKwCurrent = value;
		});
	};

	return (
		<WeekRangePicker
			minValue={agtAkumaPlanerUiStore.minKw}
			maxValue={agtAkumaPlanerUiStore.maxKw}
			opts={agtAkumaPlanerUiStore.kwsOpts}
			onMinChange={onMinChange}
			onMaxChange={onMaxChange}
			queryParam="kw"
		/>
	);
});

export const AkumaPlanerListe = observer(() => {
	const { berichteUiiStore, agtAkumaPlanerUiStore, agenturListUiStore } = useStore();
	const history = useHistoryWithQuery();

	const formatGpWochen = (val: number) => {
		return `${val} ${val === 1 ? 'Woche' : 'Wochen'}`;
	};

	const tm = useMemo(() => {
		const tm = new TableModel<AgtAkumaPlanerVM, number>();
		const cols: ITableColumn<AgtAkumaPlanerVM, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});
		cols.push({
			label: 'Teilhaber',
			path: 'agt.thCount',
			sortBy: 'agt.thCount',
			agg: [
				{
					path: 'agt.thCount',
					aggType: AggregrationType.sum,
				},
			],
		});

		AkumaPlanerArtSchema.forEach((art) => {
			cols.push({
				label: art.label,
				path: `${art.path}`,
				format: art.path === 'gpWochen' ? formatGpWochen : formatNum,
				agg: [
					{
						path: `${art.path}`,
						aggType: AggregrationType.sum,
					},
				],
			});
		});

		tm.onRowClick = (row: TableRow<AgtAkumaPlanerVM>) => {
			history.pushWithQuery({
				search: '?agtId=' + row.data.agt.agtId,
			});
		};

		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		console.log('useeffect AkumaPlanerListe');
		agtAkumaPlanerUiStore.aggreagateAgtsByKw(agtAkumaPlanerUiStore.minKwCurrent, agtAkumaPlanerUiStore.maxKwCurrent).then((result) => {
			let items = result;
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = agtAkumaPlanerUiStore.filterByAgtIdandKw(agtId);
				items = _.sortBy(items, 'bm').reverse();
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtAkumaPlanerVM[];
			}

			tm.setRowData(items);
			tm.sort();
		});
	}, [
		tm,
		berichteUiiStore.selectedAgt,
		agenturListUiStore.filterHasChanged,
		agenturListUiStore,
		agtAkumaPlanerUiStore.items,
		agtAkumaPlanerUiStore.currentKWItems,
		agtAkumaPlanerUiStore.maxKwCurrent,
		agtAkumaPlanerUiStore.minKwCurrent,
		agtAkumaPlanerUiStore,
	]);

	return (
		<>
			<div className="table-container pad-bottom-3rem">
				<AkumaPlanerOptions />
				<div className="table-container">
					<div className="pad-1rem">
						<AkumaPlanerSankeyChart />
					</div>
					<Table stickyHeader={true} tm={tm}></Table>
					<AkumaPlanerLegend />
				</div>
			</div>
		</>
	);
});
